import { MenuBlock, MenuLeaf } from '../../types/types';

export const findMenuApplication = (
  menuItems: MenuBlock[],
  appId: string
): MenuLeaf | null => {
  for (const block of menuItems) {
    for (const item of block.children ?? []) {
      if (item.appId === appId && item.app) {
        return item;
      }
      for (const child of item.children ?? []) {
        if (child.appId === appId && child.app) {
          return child;
        }
      }
    }
  }
  return null;
};
